const root = window.location.origin;

// Base paths
const home = "/home";
const login = "/login";
const donor = "/donor";
const receiver = "/receiver";

const routing = {
  root,

  login: {
    path: login,
    label: "Login",
  },

  home: {
    path: home,
    label: "Home",
  },

  // shared
  partnerships: {
    path: "/partnerships",
    label: "Partnerships",
    title: "Partnerships",
    subtitle: "Create and manage partner connections for automatic material requests",
  },

  donor: {
    root: donor,
    label: "Donor",
    donate_materials: {
      path: donor + "/donate-materials",
      label: "Donate Materials",
      title: "Material Donations",
      subtitle: "Manage and track your material donation listings",
    },
    workspace: {
      path: donor + "/workspace",
      label: "Workspace",
      title: "Workspace",
      subtitle: "Update pricing, quantities, deadlines, and pickup details to keep your listing accurate",
    },
    allocate: {
      path: donor + "/allocate",
      label: "Allocate",
      title: "Allocate Materials",
      subtitle: "Review your listings and allocate materials to receivers",
    },
    inventory: {
      path: donor + "/inventory",
      label: "Inventory",
      title: "Inventory",
      subtitle: "Track your donation history, revenue, and receiver relationships",
    },
    ghg: {
      path: donor + "/ghg",
      label: "ESG & Carbon",
      title: "ESG & Carbon Impact",
      subtitle: "Track your environmental impact and emissions avoided",
    },
    profile: {
      path: donor + "/profile",
      label: "Profile",
      title: "Profile",
      subtitle: "Manage your account settings and preferences",
    },
  },

  receiver: {
    root: receiver,
    label: "Receiver",
    material_management: {
      path: receiver + "/material-management",
      label: "Browse Materials",
      title: "Browse Materials",
      subtitle: "Find materials from nearby donors and schedule a pickup",
    },
    schedule: {
      path: receiver + "/schedule",
      label: "Schedule",
      title: "Schedule",
      subtitle: "Manage your scheduled pickups and deliveries",
    },
    inventory: {
      path: receiver + "/inventory",
      label: "Inventory",
      title: "Inventory",
      subtitle: "Track pickups, donors, and received material insights",
    },
    flow_analysis: {
      path: receiver + "/flow-analysis",
      label: "Flow Analysis",
      title: "Flow Analysis",
      subtitle: "What was recovered, what was lost — across the materials you received this period",
    },
    ghg: {
      path: receiver + "/ghg",
      label: "ESG & Carbon",
      title: "ESG & Carbon Credits",
      subtitle: "Track your greenhouse gas emission reductions",
    },
    profile: {
      path: receiver + "/profile",
      label: "Profile",
      title: "Profile",
      subtitle: "Manage your account settings and preferences",
    },
  },
};

export default routing;
